export const ROLE_LABELS = {
  superadmin: 'Суперадминистратор',
  admin: 'Администратор',
  manager: 'Менеджер',
  user: 'Пользователь',
  contractor: 'Подрядчик',
};

const ROLE_ALIASES = {
  superadmin: 'superadmin',
  superadministrator: 'superadmin',
  'суперадминистратор': 'superadmin',
  admin: 'admin',
  administrator: 'admin',
  'администратор': 'admin',
  manager: 'manager',
  'менеджер': 'manager',
  user: 'user',
  'пользователь': 'user',
  contractor: 'contractor',
  'подрядчик': 'contractor',
};

function normalizeRoleValue(value) {
  const normalized = String(value || '')
    .trim()
    .toLowerCase();

  return ROLE_ALIASES[normalized] || normalized;
}

function extractUserRoleIds(user) {
  if (!user) return [];

  const values = [];

  if (user.role) {
    values.push(user.role);
  }

  if (Array.isArray(user.roles)) {
    values.push(...user.roles);
  }

  return values
    .flatMap((value) => {
      if (!value) return [];
      if (typeof value === 'string') return [value];
      if (typeof value === 'object') {
        return [value.id, value.name, value.code, value.role, value.label].filter(Boolean);
      }
      return [];
    })
    .map(normalizeRoleValue)
    .filter(Boolean);
}

export function mapRoleIdToLabel(roleId, fallback = 'Неизвестная роль') {
  if (!roleId) return fallback;
  const normalizedRoleId = normalizeRoleValue(roleId);
  return ROLE_LABELS[normalizedRoleId] || roleId || fallback;
}

export function resolveUserRole(user, fallback = '') {
  if (!user) return fallback;
  const roleId = extractUserRoleIds(user)[0] || null;
  return mapRoleIdToLabel(roleId, fallback);
}

export function userHasRole(user, roleId) {
  if (!user || !roleId) return false;
  return extractUserRoleIds(user).includes(normalizeRoleValue(roleId));
}
